import React from "react";
import CTABlock from "../impact/ctaBlock/CTABlock";

const Footer = (props) => {
    return (
        <CTABlock showContactModal={props.showContactModal}/>
    )
}

export default Footer;